export default __webpack_public_path__ + "static/icon_b-b9490323d8ec9d9d18fc31175ce2443d.png";